/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var LoginRequest;
(function (LoginRequest) {
    var brand;
    (function (brand) {
        brand["BRAND_UNSPECIFIED"] = "BRAND_UNSPECIFIED";
        brand["BRAND_FILETAX"] = "BRAND_FILETAX";
        brand["BRAND_FILESMART"] = "BRAND_FILESMART";
    })(brand = LoginRequest.brand || (LoginRequest.brand = {}));
    var tokenType;
    (function (tokenType) {
        tokenType["TOKEN_TYPE_TRANSIENT"] = "TOKEN_TYPE_TRANSIENT";
        tokenType["TOKEN_TYPE_JWT"] = "TOKEN_TYPE_JWT";
    })(tokenType = LoginRequest.tokenType || (LoginRequest.tokenType = {}));
})(LoginRequest || (LoginRequest = {}));
//# sourceMappingURL=LoginRequest.js.map